import { parse } from 'date-fns';

function removeQuotes(str) {
  return str.replaceAll('"', '');
}

export default function convertXRayFileToShotObjects(fileContent) {
  const shots = fileContent.split(/\r?\n/).map((lineContent) => {
    const lineContentWithoutTrailingComma = lineContent.replace(/,$/, '');
    const [date, kV, mAs, mA, ms, ...operators] = lineContentWithoutTrailingComma.split(',');

    // We updated shots to get precision down to the second, but we want to be able to parse older files
    // that only have minute precision, so we try both formats when parsing the date
    // Newest format with seconds precision: yyyy-MM-dd kk:mm:ss
    let parsedDate = parse(date, 'yyyy-MM-dd kk:mm:ss', new Date());
    console.debug('Parsed date with seconds precision', { date, parsedDate });

    // v2 format which discarded seconds precision: yyyy-MM-dd kk:mm
    if (Number.isNaN(parsedDate.getTime())) {
      parsedDate = parse(date, 'yyyy-MM-dd kk:mm', new Date());
    }
    // Initial format with second precision but using _ as separator instead of space: yyyy-MM-dd_kk:mm:ss
    if (Number.isNaN(parsedDate.getTime())) {
      parsedDate = parse(date, 'yyyy-MM-dd_kk:mm:ss', new Date());
    }
    return {
      date: parsedDate,
      kV: parseInt(kV, 10),
      mAs: parseFloat(mAs),
      mA: parseInt(mA, 10),
      ms: parseInt(ms, 10),
      operators: operators.length === 0 ? undefined : operators.map(removeQuotes),
    };
  });
  const shotsWithoutNanKV = shots.filter((shot) => !Number.isNaN(shot.kV));
  return shotsWithoutNanKV;
}
